import React from 'react';
import PropTypes from 'prop-types';
import registerHOC from 'HOC/registerHOC';
import AutoFocusIfNonTouchDevice from 'components/AutoFocusIfNonTouchDevice';
import Button from 'components/Button';
import SubFooter from 'components/SubFooter';
import PhoneNumberField from 'components/PhoneNumberField';
import InvisibleSubmit from 'components/InvisibleSubmit';
import ModalComponents from './ModalComponents';

const Register = ({
  title,
  values: { phoneNumberField },
  errors,
  touched,
  handleBlur,
  handleSubmit,
  setFieldValue,
}) => (
  <ModalComponents.ModalContent>
    <ModalComponents.ContentContainer>
      <ModalComponents.Title>{title}</ModalComponents.Title>
      <ModalComponents.Form onSubmit={handleSubmit}>
        <AutoFocusIfNonTouchDevice>
          {autoFocus => (
            <PhoneNumberField
              label="Enter your Mobile Number"
              value={phoneNumberField}
              name="phoneNumberField"
              type="tel"
              onChange={v => setFieldValue('phoneNumberField', v)}
              onBlur={handleBlur}
              helperText={touched.phoneNumberField && errors.phoneNumberField}
              error={!!(touched.phoneNumberField && errors.phoneNumberField)}
              fullWidth
              autoFocus={autoFocus}
            />
          )}
        </AutoFocusIfNonTouchDevice>
        <ModalComponents.FormButton>
          <Button fullWidth onClick={handleSubmit}>
            Next
          </Button>
        </ModalComponents.FormButton>
        <InvisibleSubmit />
      </ModalComponents.Form>
      <ModalComponents.Separator />
    </ModalComponents.ContentContainer>
    <SubFooter />
  </ModalComponents.ModalContent>
);

Register.propTypes = {
  title: PropTypes.string.isRequired,
  values: PropTypes.shape({
    phoneNumberField: PropTypes.string,
  }).isRequired,
  errors: PropTypes.shape({
    phoneNumberField: PropTypes.string,
  }).isRequired,
  touched: PropTypes.shape({
    phoneNumberField: PropTypes.bool,
  }).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default registerHOC(Register);
